import React from "react";
import { Meta } from "./Meta.js";
import { CommentForm } from "./CommentForm.js";
import { useLoadEffect } from "../../../react/load/useLoadEffect.js";
import { requestGetJson } from "../../../packages/fetcher/fetcherFunctions.js";
import { CommentPublicData } from "../../../organizer/model/comments/CommentPublicData.js";
import { formatComment } from "../../../organizer/model/comments/formatComment.js";
import { COMMENTS_CLOSED } from "../../../config/commentSystem.js";

type Props = {
  postId: string;
  slug: string;
  title: string;
};

/**
 * Renders the comments list.
 */
export const Comments = ({ postId, slug, title }: Props) => {
  const result = useLoadEffect(`comments-${postId}`, async () => {
    const url = `/api/post/${postId}/public-comments`;
    const comments = await requestGetJson<CommentPublicData[]>(url);
    return comments.filter((comment) => !comment.content.startsWith("__test"));
  });

  return (
    <>
      <h3>Comments</h3>
      {result.state === "success" && result.data.length === 0 && <p>No comments have been added so far.</p>}
      {result.state === "error" && <p className="error">Failed to load comments.</p>}
      {result.state === "loading" && <p className="loader">Loading comments ...</p>}
      {result.state === "success" && (
        <div>
          {result.data.map((comment) => (
            <div className="comment" key={comment.id} id={`comment-${comment.id}`}>
              <Meta comment={comment} />
              <div>
                {formatComment(comment.content).map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="print-none">
        {COMMENTS_CLOSED ? (
          <p>
            Comments system is closed. Please send any feedback directly using{" "}
            <a href="/#contacts--links">contacts</a>.
          </p>
        ) : (
          <>
            <h3>Add comment</h3>
            <CommentForm postId={postId} slug={slug} title={title} updateComments={result.reload} />
          </>
        )}
      </div>
    </>
  );
};
